import { TypeFromSchemaValidator } from "../../..";
import { ApiClient } from "../../../api-client";
import { ApiClientError } from "../../../errors";
import schemaValidators from "./schema-validators";
import EventEmitter from "events";

type HttpWebNavigationEvent = TypeFromSchemaValidator<(typeof schemaValidators)["httpWebNavigationEvent"]>;
export class HttpLoggerClient extends ApiClient<typeof schemaValidators> {
	readonly emitter: EventEmitter;
	constructor(config: ApiClient["config"], emitter: EventEmitter) {
		super(config, schemaValidators);
		this.emitter = emitter;
	}

	webNavigation = async (
		proctoringSessionId: string,
		name: "webRequest" | "webNavigation",
		details: HttpWebNavigationEvent["details"],
	) => {
		try {
			const event = {
				type: "web navigation",
				name: name,
				time: new Date(),
				details: details,
			};
			this.emitter.emit("log", event);
			if (schemaValidators.httpWebNavigationEvent.validate(event)) {
				const resp = await super.fetch(`${this.config.verityOrigin}/api/verity/quiz/event/${proctoringSessionId}`, {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(event),
					credentials: "include",
				});
				if (resp.ok) {
					return true;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
